const routes = [
  {
    index: true,
    label: 'Ahammad Shawki',
    path: '/',
  },
  {
    label: 'About',
    path: '/about',
  },
  {
    label: 'Resume',
    path: '/resume',
  },
  {
    label: 'Projects',
    path: '/projects',
  },
  {
    label: 'Publications',
    path: '/publications',
  },
  {
    label: 'Hire Me',
    path: '/contact',
  },
];

export default routes;
